const CLASS_IS_LOADING = 'is-loading';


const loaderMixin = {
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    loaderAdd(el = null, loadingClass = CLASS_IS_LOADING, changeFlag = true) {
      const target = el || this.$el;
      if (target) {
        target.classList.add(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = true;
      }
    },
    loaderRemove(el = null, loadingClass = CLASS_IS_LOADING, changeFlag = true) {
      const target = el || this.$el;
      if (target) {
        target.classList.remove(loadingClass);
      }
      if (changeFlag) {
        this.isLoading = false;
      }
    },
  },
};


export default loaderMixin;



// WEBPACK FOOTER //
// ./src/mixins/loader.js